<template>
  <div id="SectionFastTrackProcess">
    <UIContainer class="SectionFastTrackProcess__container">
      <SectionTitle class="SectionReviews__title">
        <template #title> Proven fast-track process </template>
        <template #description>
          Our certified Training Partners are here to help you improve your
          score and implement lasting sustainability improvements. We offer a
          proven, fast-track process to success.
        </template>
      </SectionTitle>

      <div class="SectionFastTrackProcess__carousel">
        <UICarousel :items="steps">
          <template #card="{ item }">
            <RoadmapCard
              :index="(item as Step).index"
              :title="(item as Step).title"
              :description="(item as Step).description"
              :image="(item as Step).image"
              :backgroundColor="(item as Step).backgroundColor"
            />
          </template>
        </UICarousel>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import { ref } from 'vue'
import UICarousel from '@/views/components/UICarousel.vue'
import RoadmapCard from '@/views/components/cards/RoadmapCard.vue'
import requestAndTrack from './assets/fastTrackProcess/requestAndTrack.svg'
import viewAnalyzeResults from './assets/fastTrackProcess/viewAnalyzeResults.png'
import checkMitigate from './assets/fastTrackProcess/checkMitigate.png'
import scaleYourImpact from './assets/fastTrackProcess/scaleYourImpact.svg'

type Step = {
  index: number
  title: string
  description: string
  image: string
  backgroundColor?: string
}

const steps = ref<Step[]>([
  {
    index: 1,
    title: 'Request & track',
    description:
      'Seamlessly request and monitor the status of supplier assessments directly within the Sustainalyse platform, eliminating spreadsheet chaos.',
    image: requestAndTrack,
    backgroundColor: '#FFFFFF',
  },
  {
    index: 2,
    title: 'View & analyze results',
    description:
      'Instantly view supplier performance with intuitive scorecards, medals, and progress dashboards. Identify leaders and laggards at a glance.',
    image: viewAnalyzeResults,
    backgroundColor: '#F9F9FB',
  },
  {
    index: 3,
    title: 'Check & mitigate risks',
    description:
      'Go deeper than a single score. Review detailed sustainability profiles and supplier-specific carbon scorecards to check for risks and advance your climate goals.',
    image: checkMitigate,
    backgroundColor: '#EFF1F5',
  },
  {
    index: 4,
    title: 'Scale your impact',
    description:
      'Embed powerful sustainability insights directly where you work—across your procurement, supply chain, ERP, and risk management tools.',
    image: scaleYourImpact,
    backgroundColor: '#DCDFEA',
  },
])
</script>

<style lang="scss" scoped>
#SectionFastTrackProcess {
  position: relative;
  background-color: $color-white;
  padding: 5rem 0;

  .SectionFastTrackProcess__container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .SectionReviews__title {
    max-width: 48rem;
  }

  .SectionFastTrackProcess__carousel {
    margin-top: 2rem;
  }

  .RoadmapCard {
    height: 26.25rem;
    overflow: hidden;

    :deep(.RoadmapCard__image) {
      width: 100%;
      height: auto;
    }
  }
}
</style>
